const heroImage = require('./images/pasted-image-0-4.png');

// Export images for use in components
export {
  heroImage
};